import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Order, OrderCreationRequest} from "../../../models/order";
import {CouponCodeRequest} from "../../../models/coupon-code-request";
import {CouponCodeResponse} from "../../../models/coupon-code-response";
import {PlaceOption, StreetOption} from "../models/address-option";

@Injectable({
    providedIn: 'root'
})
export class CheckoutService {

    constructor(private readonly httpClient: HttpClient) {
    }

    submitOrder(orderCreationRequest: OrderCreationRequest): Observable<Order> {
        const url: string = environment.domain.backend + environment.api.orders;
        return this.httpClient.post<Order>(url, orderCreationRequest);
    }

    applyCoupon(couponCodeRequest: CouponCodeRequest): Observable<CouponCodeResponse> {
        const url: string = environment.domain.backend + environment.api.orders + "/apply-coupon"
        return this.httpClient.post<CouponCodeResponse>(url, couponCodeRequest);
    }

    searchPlaces(search: string, limit: number = 10): Observable<PlaceOption[]> {
        const url = `${environment.domain.backend}/checkout/places?search=${encodeURIComponent(search)}&limit=${limit}`;
        return this.httpClient.get<PlaceOption[]>(url);
    }

    searchStreets(placeId: number, search: string, limit: number = 10): Observable<StreetOption[]> {
        const url = `${environment.domain.backend}/checkout/places/${placeId}/streets?search=${encodeURIComponent(search)}&limit=${limit}`;
        return this.httpClient.get<StreetOption[]>(url);
    }
}
